const ITEMS = [
    "ONE-TAP FILTERS",
    "REELS & TIKTOK",
    "COLOR GRADES",
    "NO APP NEEDED",
    "EXPORT IN SECONDS",
    "MADE FOR MOBILE",
];

function Row({ ariaHidden }) {
    return (
        <div aria-hidden={ariaHidden || undefined} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-7 font-display text-2xl font-extrabold tracking-tight text-slate-200 sm:text-3xl">
                        {item}
                    </span>
                    <svg width="18" height="18" viewBox="0 0 20 20" className="shrink-0 text-amberx" fill="currentColor" aria-hidden="true">
                        <path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4L10 0z" />
                    </svg>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section className="border-y border-white/10 bg-surface/60 py-6">
            <div className="overflow-hidden">
                <div className="marquee-track">
                    <Row />
                    <Row ariaHidden />
                </div>
            </div>
        </section>
    );
}
